(ns practitest.frontend.components.overlay
  (:require ["react-bootstrap/Overlay" :as Overlay]
            ["react-bootstrap/OverlayTrigger" :as OverlayTrigger]
            [reagent.dom]
            [reagent.core :as reagent]
            [goog.object :as gobj]
            [practitest.frontend.common.dom :as dom]))

(defn hide!
  [overlay-state]
  (swap! overlay-state assoc :show? false))

(defn show?
  [overlay-state]
  (:show? @overlay-state))

(defn on-click-handler
  [overlay-state e]
  (swap! overlay-state (fn [s]
                         (-> s
                             (update :show? not)
                             (assoc :target (.-target e))))))

(defn make-on-click-handler
  [overlay-state]
  (reagent/partial on-click-handler overlay-state))

;; Supported options:
;; offset [0 10]
;; strategy :fixed/:absolute
;; TODO: more options
(defn convert-popper-config
  [popper-config]
  (let [retval #js {}]
    (when-let [offset (:offset popper-config)]
      (gobj/set retval
                "modifiers"
                #js [#js {:name    "offset"
                          :options #js {:offset (clj->js offset)}}]))

    (when-let [strategy (:strategy popper-config)]
      (gobj/set retval
                "strategy"
                (name strategy)))

    retval))

(defn overlay
  ^{:deprecated "use floating-ui-overlay instead"}
  [options trigger-element content]
  (let [overlay-state (or (:overlay-state options)
                          (reagent/atom {:show? false}))
        container-ref (or (:container-ref options)
                          (atom nil))]
    (fn [options trigger-element content]
      [(if (:container-ref options)
         :<>
         :span)
       (when-not (:container-ref options)
         {:ref (dom/root-ref-handler container-ref)})

       (let [container-ref (or (:container-ref options)
                               container-ref)
             show? (boolean (or (show? overlay-state) false))]
         [:r> Overlay
          #js {:show         show?
               :onHide       #(hide! overlay-state)
               :rootClose    true
               :flip         (or (:flip? options) true)
               :popperConfig (convert-popper-config (:popper-config options))
               :placement    (or (:placement options) "bottom")
               :target       (or (:target options)
                                 (fn []
                                   (:target @overlay-state)))
               :container    (fn []
                               @container-ref)}

          (reagent/as-element content)])

       (if (fn? trigger-element)
         (trigger-element overlay-state)
         trigger-element)])))

;; Useful for hover effects
(defn overlay-trigger
  [options overlay-body-fn trigger-element-fn]
  (let [element-ref (atom nil)
        popper-ref (atom nil)]
    (reagent/create-class
      {:component-did-mount  (fn [this]
                               (reset! element-ref (reagent.dom/dom-node this)))
       :component-did-update (fn [this old-argv old-state snapshot]
                               (when-let [popper @popper-ref]
                                 ;; Reposition on updates
                                 (.scheduleUpdate popper)))
       :reagent-render
       (fn [options overlay-body-fn trigger-element-fn]
         ;; It's too much pain implementing correct hovering logic with delay
         ;; so we're using OverlayTrigger here
         (let [props #js {:placement    (or (:placement options) "top")
                          :delay        (let [delay (:delay options)]
                                          #js {:show (or (:show delay) 400)
                                               :hide (or (:hide delay) 300)})
                          :rootClose    (:root-close? options)
                          :overlay      (fn [tooltip-props]
                                          (when-not @popper-ref
                                            (reset! popper-ref (gobj/get tooltip-props "popper")))

                                          (overlay-body-fn tooltip-props))

                          :popperConfig (convert-popper-config (:popper-config options))

                          :container    (fn []
                                          (dom/get-root-node @element-ref))}]

           (when-some [transition (:transition options)]
             (gobj/set props "transition" transition))

           (reagent/create-element
             OverlayTrigger
             props
             (fn [props]
               (trigger-element-fn props)))))})))
